import { render, staticRenderFns } from "./ProjectConfiguration.vue?vue&type=template&id=95ef12f6&scoped=true"
import script from "./ProjectConfiguration.vue?vue&type=script&lang=js"
export * from "./ProjectConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ProjectConfiguration.vue?vue&type=style&index=0&id=95ef12f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ef12f6",
  null
  
)

export default component.exports